<mat-sidenav-container>
	<mat-sidenav #sidenav mode="side" position="end">
		<app-document-viewer (close)="toggleSlide(); documentLoadUnsubscriber$.next()" *ngIf="viewDocument"
			[documentDetails]="selectedDocumentDetails"></app-document-viewer>
		<app-loader *ngIf="viewEmail"></app-loader>
	</mat-sidenav>


	<mat-sidenav-content [class.opened]="isOpened">
		<div class="main-container lg-view" [ngClass]="{'extended': !haveAccess || isReadonly || (!!siteNote && siteNote.isCompleted)}">
			<h3>Site Note Details</h3>
			<div *ngIf="hasSiteNoteLoadingError && !!siteNoteLoadingErrorMsg" class="error">
				<p>{{siteNoteLoadingErrorMsg}}</p>
			</div>
			<div class="item-container" *ngIf="!!siteNote" @fadeIn>
				<div class="item-details">
					<span class="address" *ngIf="siteNote.siteAddress">{{ siteNote.siteAddress }}</span>

					<span class="resource">
						<span *ngIf="siteNote.locationName" class="resource-value">
							<span class="label">Location:</span>{{siteNote.locationName}}
						</span>
					</span>
					<span class="resource">
						<span *ngIf="siteNote.assetName" class="resource-value">
							<span class="label">Asset:</span>{{siteNote.assetName}}
						</span>
					</span>

					<span class="comment">
						{{ siteNote.message }}
					</span>

					<span class="emergency" *ngIf="siteNote.isEmergency">
						<span class="label">Emergency:</span>
						YES
					</span>
				
					<span class="notify-other" *ngIf="siteNote.notifyOthers">
						<span class="label">Notify Other:</span>
						{{ siteNote.notifyOthers ? 'YES' : 'NO' }}
					</span>

					<span class="created-by-on">
						Posted by {{ siteNote.createdBy }}
						on {{ moment(siteNote.createdOn).format('MM/DD/YYYY hh:mm A') }}
					</span>

					<span class="completion-status"
						[class.required]="siteNote.isCompletionRequired && !siteNote.isCompleted"
						[class.completed]="siteNote.isCompletionRequired && siteNote.isCompleted"
						*ngIf="siteNote.isCompletionRequired">
						{{ siteNote.isCompleted ? 'Item Completed' : 'Completion Required' }}
					</span>
					<span class="assigned-to" *ngIf="siteNote.assignedUserName">
						<span class="label">Assigned to:</span>
						{{ siteNote.assignedUserName }}
					</span>
					<span class="completed-by-on" *ngIf="siteNote.isCompletionRequired && siteNote.isCompleted">
						Completed by {{ siteNote.completedBy }}
						on {{ moment(siteNote.completedOn).format('MM/DD/YYYY hh:mm A') }}
					</span>

					<span class="photo-count" *ngIf="!!siteNote.photoCount">({{ siteNote.photoCount }} {{
						siteNote.photoCount > 1 ? 'photos' : 'photo' }})</span>

					<div class="documents-container" *ngIf="!isDocumentsLoading && documents?.length">
						<div class="document" *ngFor="let document of documents" (click)="showDocument(document)">
							<div class="thumbnail-container">
								<img [class.no-thumbnail]="!document.thumbnailBase64" [src]="imageThumnail(document)" />
							</div>
							<div class="document-name">
								<span>{{ document.name }}</span>
							</div>
						</div>
					</div>

					<app-loader [hasTransparency]="true" [isInline]="true" [loaderMessage]="'Loading Photos'"
						*ngIf="isDocumentsLoading"></app-loader>

				</div>
			</div>

			<input type="file" hidden #fileInput>
		</div>

		<div class="actions-container md-view" *ngIf="!!siteNote && !isLoading && !isReadonly && haveAccess">
			<ng-container>
				<action-button @fadeIn *ngIf="!siteNote.isCompleted" [icon]="ButtonIcons.Edit" 
				[name]="'Edit'"
				[clickAction]="startEditMode.bind(self)"></action-button>

				<action-button @fadeIn *ngIf="siteNote.isCompletionRequired && !siteNote.isCompleted" [icon]="ButtonIcons.StatusChange" 
				[name]="'Complete'"
				[clickAction]="startCompleteMode.bind(self)">
				</action-button>

				<action-button @fadeIn [icon]="ButtonIcons.Link" 
				[name]="'Copy Link'"
				[cdkCopyToClipboard]="location.origin + '/' + siteNote.urlHash" [clickAction]="triggerCopyToast.bind(self)"></action-button>

				<action-button @fadeIn *ngIf="!siteNote.isCompleted" [clickAction]="onDeletePressed.bind(self)" [icon]="ButtonIcons.Delete" 
				[name]="'Delete'">
				</action-button>
			</ng-container>
		</div>
	</mat-sidenav-content>
</mat-sidenav-container>

<generic-modal #deleteConfirmationModal>
	<ng-template #modalHeading let-data="data">
		<strong>Delete confirmation</strong>
	</ng-template>
	<ng-template #modalBody>
		<p>Are you sure you want to delete this Site Note?</p>
	</ng-template>

	<ng-template #modalActions>
		<button mat-raised-button type="button" class="primary"
			(click)="deleteSiteNote()">Yes</button>

		<button mat-raised-button class="secondary" type="button" (click)="onCancelDeletion()">Cancel</button>
	</ng-template>
</generic-modal>